import {clearOutput} from '@/utils/general'

const ACCESS_BY_DIALOG = 1;
const ACCESS_BY_WEEKUNDERSTANDING = 2;


export const civiiChat = {
    iniciarConexion: function({output}){
        let userCredentials = getUserCredentialsFromStorage();
        if(output) {
            return startCiviiChatByCiviiResponse(output, userCredentials);
        } else {
            startCiviiChatByScript(userCredentials);
        }
        
    },
    quieroHablarConAgente: function({output}) {
        window.civii.$store.commit('resetWeakUnderstandingResponses');
        if(output.input === 'true'){
            return civiiChat.iniciarConexion({output});
        } else {
            output.outputWatson.json_response.push(
                {
                    type: 'Normal',
                    side: 'left',
                    messages: [
                        { text: window.civiiConf.civiiChat.keepTalkingWithCiviiMessage }
                    ]
                }
            )
            return clearOutput(output, 'civiiChat');
        }
    }
}

function startCiviiChatByScript(userCredentials){
    if(allCredentialsCaptured(userCredentials)){
        startCiviiChat(userCredentials, ACCESS_BY_WEEKUNDERSTANDING);
    } else {
        throw new Error('User credentials not found to start civii chat connection');
    }
}

function startCiviiChatByCiviiResponse(output, userCredentials){
    startCiviiChat(userCredentials, ACCESS_BY_DIALOG);
    return clearOutput(output, 'civiiChat');
}

function startCiviiChat(userCredentials, accessTypeId){
    clearCiviiChatStrogeItems();
    let civiiContext = JSON.parse(localStorage.getItem('civiiContext'));
    let workspaceId = window.civiiConf.workspaceId;
    let conversationId = civiiContext.conversation_id;
    const conectionOptions = {
        workspaceId: workspaceId,
        conversationId: conversationId,
        accessTypeId: accessTypeId,
        userCredentials: userCredentials
    }
    window.civii.$store.dispatch('civiiChat/createConnection', conectionOptions);
}

function allCredentialsCaptured(userCredentials) {
    return userCredentials.idUsuario && userCredentials.nombreUsuario && userCredentials.workspaceId;
}

function clearCiviiChatStrogeItems(){
    sessionStorage.removeItem('civiichatFullname');
    sessionStorage.removeItem('civiichatIdUser');
}

function getUserCredentialsFromStorage(){
    let fristname = getStorageItemOrNull('firstname');
    let lastname = getStorageItemOrNull('lastname');
    let fullname = null
    if(fristname) {
        fullname = fristname + ' ' + (lastname ? lastname : '');
        fullname = fullname.trim();
    } else {
        fullname = getStorageItemOrNull('civiichatFullname');
    }
    return {
        idUsuario: getStorageItemOrNull('nroIdentificacion') || getStorageItemOrNull('civiichatIdUser'),
        nombreUsuario: fullname,
        email: getStorageItemOrNull('username') || getStorageItemOrNull('civiichatEmail'),
        phone: getStorageItemOrNull('civiichatPhone'),
        workspaceId: window.civiiConf.workspaceId
    }
}

function getStorageItemOrNull(storageItemKey){
    return sessionStorage.getItem(storageItemKey) || null;
}



// WEBPACK FOOTER //
// ./src/civii-chat/actions/civiiChatActions.js